import * as React from "react";

export interface HeaderProps {
  title: string;
  logo: string;
  logoWidth: number;
  logoHeight: number;
  message: string;
}

export default class Header extends React.PureComponent<HeaderProps> {
  render() {
    const { title, logo, message, logoWidth, logoHeight } = this.props;

    return (
      <section className="ms-welcome__header ms-u-fadeIn500">
        <img width={logoWidth} height={logoHeight} src={logo} alt={title} title={title} />
        <h1 className="ms-fontSize-su ms-fontWeight-light ms-fontColor-neutralPrimary">{message}</h1>
      </section>
    );
  }
}
